export const getSuccessAvailability = (state) => state.successAvailability.availabilityInfo
